import { Component, } from '@angular/core';
import { Observable } from '@angular/core/src/facade/async';
import { Http } from '@angular/http';
import { ConstantClass } from '../admisform/admisform.component';
import { AdmissionFormService } from '../admisform/admisformservice';
import { NavModalComponent } from '../core/component/NavModal.Component';

@Component({
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent extends NavModalComponent<any> {
  Entity: any;

  constructor(
    private admissionService: AdmissionFormService,
    private _httpClient : Http
  ){
    super(admissionService);


    this.getData().subscribe((i: ConstantClass) => {
  
      if (
        i.Clients.length > 0 &&
        i.Clients.filter((o) => o.hostname === window.location.hostname)[0]
      ) {
        let obj = i.Clients.filter(
          (o) => o.hostname === window.location.hostname
        )[0];
        
        
      if( obj && obj.name){

        this.Entity = obj.name;
      }
      this.localStorage.set("Entity" , obj.name)
    }
    
  });
    
  }

 async ngOnInit() {


  }

  public getData(): Observable <any>{
    
    const a  = this._httpClient
    .get("../../assets/IXS/resultJSON.json")
    .map((res: any) =>{
      return res.json();
    });
      return a; 
    }


}



// WEBPACK FOOTER //
// ./src/app/about/about.component.ts